import React, {useState} from 'react';
import leftArrow from '../../assets/images/gallery/icons/arrow-left.svg';
import rightArrow from '../../assets/images/gallery/icons/arrow-right.svg';

interface CarouselProps {
  images: string[];
  index: number;
}

function Carousel({images, index}: CarouselProps) {
  const [displayImageIndex, setDisplayImageIndex] = useState(index);

  const swipeRight = () => {
    if(displayImageIndex<images.length-1) {
      setDisplayImageIndex(prev => prev + 1);
    }
  }

  const swipeLeft = () => {
    if (displayImageIndex > 0) {
      setDisplayImageIndex(prev => prev-1);
    }
  }

  return (
    <div className="h-[13rem] sm:h-[25rem] md:h-[30rem] lg:h-[40rem] relative">
      <img className="h-full w-full rounded" src={images[displayImageIndex]} alt="project" />
      <div className="absolute left-0 right-0 top-0 bottom-0 flex justify-between items-center z-30">
        <button className="h-full w-1/2 flex justify-start items-center" onClick={swipeLeft}>
          <img className="bg-white/80 h-10 sm:h-16 rounded-full mx-3" src={leftArrow} alt="previous" />
        </button>
        <button className="h-full w-1/2 flex justify-end items-center" onClick={swipeRight}>
          <img className="bg-white/80 h-10 sm:h-16 rounded-full mx-3" src={rightArrow} alt="next" />
        </button>
      </div>
    </div>
  );
}

export default Carousel;
